"use client";

import { SDUIUPLTComponentsPerClientSize } from "@faire/retailer-visitor-shared/components/UPLT/calculateNumComponentsPerClientSize";
import { useUPLTLoadedStore } from "@faire/web--source/common/performance/userPerceivedLoadTiming/UserPerceivedLoadTimingContext";
import * as React from "react";
import { useEffect } from "react";

interface UPLTSetterProps {
  numComponentsPerClientSize?: SDUIUPLTComponentsPerClientSize;
  pageLoadKey?: string;
  ignoreImages?: boolean;
}

export const UPLTSetter: React.FC<UPLTSetterProps> = (props) => {
  const [, setStore] = useUPLTLoadedStore([]);
  useEffect(() => {
    setStore({
      numComponentsPerClientSize: props.numComponentsPerClientSize,
      ignoreImages: props.ignoreImages,
    });
  }, [props.numComponentsPerClientSize, props.ignoreImages, setStore]);
  return null;
};
